import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MarketingDashboard from "./MarketingDashboard";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
function MarketingDashboardPage({ subcategoryToken }) {
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader />
      </MDBox>
      <MarketingDashboard subcategoryToken={subcategoryToken} />
    </DashboardLayout>
  );
}

export default MarketingDashboardPage;
